<template>
  <div class="chart">
    <div :id="report.id" :style="{width: report.width, height: report.height}"></div>
  </div>
</template>

<script>
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/line')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
export default {
  name: "CurveChart",
  props: {
    report: {
      type: Array | Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {}
  },
  mounted() {
    this.drawLine()
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.report.id))
      // 绘制图表
      myChart.setOption({
        title: {
          text: this.report.name,
          textStyle: {
            fontSize: 13,
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        toolbox: {
          show: true,
          feature: {
            mark: {show: true},
            dataView: {show: true, readOnly: true},
            // restore: { show: true },
            // saveAsImage: { show: true }
          }
        },
        series: [
          {
            name: this.report.name,
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            // radius: '50%',
            data: this.report.data,
          }
        ]
      });
    }
  }
}
</script>

<style scoped lang="scss">
.chart {
  background: #ffffff;
  margin-right: 10px;
  padding-top: 10px;
  border-radius: 8px;
}
</style>